function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Warning(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.903 5.221a1.042 1.042 0 00-1.806 0l-.646-.372.646.372L3.89 17.752l-.605-.347.605.347c-.399.695.102 1.561.903 1.561h14.412c.8 0 1.302-.866.903-1.56L12.903 5.22l.65-.374-.65.374zm-3.106-.748c.977-1.7 3.43-1.7 4.406 0l7.206 12.532c.974 1.694-.249 3.808-2.203 3.808H4.793c-1.954 0-3.177-2.114-2.203-3.808L9.797 4.473zM12 8.563a.75.75 0 01.75.75v3.583a.75.75 0 01-1.5 0V9.313a.75.75 0 01.75-.75zm.51 7.359a.75.75 0 01.056 1.059l-.009.01a.75.75 0 11-1.114-1.004l.009-.01a.75.75 0 011.059-.055z",
    clipRule: "evenodd"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Warning);
export default ForwardRef;